import type { NoiseParameters } from "../../core/effects/noise";

function mulberry32(seed: number) {
  let value = seed >>> 0;
  return () => {
    value += 0x6d2b79f5;
    let t = value;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function renderNoise(
  target: CanvasRenderingContext2D,
  source: CanvasImageSource,
  width: number,
  height: number,
  parameters: NoiseParameters,
) {
  target.clearRect(0, 0, width, height);
  target.drawImage(source, 0, 0, width, height);

  const imageData = target.getImageData(0, 0, width, height);
  const pixels = imageData.data;
  const random = mulberry32(Math.round(parameters.seed));
  const amount = Math.max(0, Math.min(1, parameters.amount)) * 255;

  for (let index = 0; index < pixels.length; index += 4) {
    if (parameters.monochrome) {
      const grain = (random() * 2 - 1) * amount;
      pixels[index] = Math.max(0, Math.min(255, (pixels[index] ?? 0) + grain));
      pixels[index + 1] = Math.max(0, Math.min(255, (pixels[index + 1] ?? 0) + grain));
      pixels[index + 2] = Math.max(0, Math.min(255, (pixels[index + 2] ?? 0) + grain));
    } else {
      pixels[index] = Math.max(0, Math.min(255, (pixels[index] ?? 0) + (random() * 2 - 1) * amount));
      pixels[index + 1] = Math.max(0, Math.min(255, (pixels[index + 1] ?? 0) + (random() * 2 - 1) * amount));
      pixels[index + 2] = Math.max(0, Math.min(255, (pixels[index + 2] ?? 0) + (random() * 2 - 1) * amount));
    }
  }

  target.putImageData(imageData, 0, 0);
}
